import type { ReactNode } from "react";
import { useAuth } from "@clerk/clerk-react";
import { useProfile } from "@/hooks/use-profile";
import { RedesignNavContext, type RedesignNavState } from "@/lib/redesignNav";

/** Reads the server switch once, from the signed-in profile, for the whole app. */
export function RedesignNavProvider({ children }: { children: ReactNode }) {
  const { isLoaded, isSignedIn } = useAuth();
  const signedIn = isLoaded === true && isSignedIn === true;
  const profile = useProfile({ enabled: signedIn });
  const state: RedesignNavState = !signedIn
    ? "off"
    : profile.data
      ? profile.data.features?.redesign_nav === true
        ? "on"
        : "off"
      : profile.isError
        ? "off"
        : "unknown";
  return <RedesignNavContext.Provider value={state}>{children}</RedesignNavContext.Provider>;
}

/** For tests: render a subtree with the switch in a given state. */
export function RedesignNavStateProvider({
  value,
  children,
}: {
  value: RedesignNavState;
  children: ReactNode;
}) {
  return <RedesignNavContext.Provider value={value}>{children}</RedesignNavContext.Provider>;
}
